import { Button, Checkbox, Popover } from 'antd';
import React, { ReactElement, useContext } from 'react';

import useDispatchSetterStore from '../hooks/useDispatchSetterStore';
import useDynamicSelector from '../hooks/useDynamicSelector';
import { SmxPropsTableContext } from '../providers/propsTableProvider';
import { getSetterTable, ITableState } from '../store/slices/tableSlice';
import { TableColumnOptionsType, TableColumnSmxType } from '../types';
import useProcessedColumns from './hooks/useProcessedColumns';

interface IControlPanelDropdown {
    icon?: ReactElement;
    title?: string;
    type?: 'link' | 'text' | 'default' | 'primary' | 'dashed' | undefined;
    columns: TableColumnSmxType[];
}

const ControlPanelDropdown: React.FC<IControlPanelDropdown> = ({ icon, title, type, columns }) => {
    const { nameQuery, prefixStore } = useContext(SmxPropsTableContext);
    const setterTable = useDispatchSetterStore<ITableState>(getSetterTable(nameQuery + prefixStore));

    const checkedList = useDynamicSelector('table', 'checkedList');

    const options = useProcessedColumns<TableColumnOptionsType>(columns, 'options');

    const onChange = (value: string[]) => {
        console.log(value, 'value');
        setterTable({ checkedList: value });
    };

    const content = (
        <Checkbox.Group
            value={checkedList}
            options={options}
            onChange={onChange}
            style={{ flexDirection: 'column', gap: 5 }}
        />
    );

    return (
        <Popover
            content={<div style={{ maxHeight: 350, overflowY: 'scroll' }}>{content}</div>}
            title="Show columns:"
            placement="bottomRight"
            style={{ width: 50 }}
        >
            <Button icon={icon} type={type}>
                {title || null}
            </Button>
        </Popover>
    );
};

export default ControlPanelDropdown;
